import { checkPermission } from "@ROM/Permissions/utils";

export const canAccessPriceListsInCompanyAdmin = (user) => checkPermission(user, "company:admin:price-lists");

export const canListPriceList = (user) => checkPermission(user, "price-lists:index");
export const canCreatePriceList = (user) => checkPermission(user, "price-lists:create");
export const canViewPriceList = (user) => checkPermission(user, "price-lists:show");
export const canEditPriceList = (user) => checkPermission(user, "price-lists:update");
export const canDeletePriceList = (user) => checkPermission(user, "price-lists:delete");
